var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8211 0H9.49626L5.51172 3H7.8365L11.8211 0Z",
    fill: "#D83C38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8385 0H13.4806L9.49609 3H11.8209L15.8385 0Z",
    fill: "#D83C38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4805 3.00006H17.0003V0.500057C17.0003 0.461491 16.9867 0.427424 16.9785 0.391357L13.4805 3.00006Z",
    fill: "#D83C38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49414 3H3.85213L7.8367 0H5.51188L1.49414 3Z",
    fill: "#D83C38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5C0 15.7764 0.22276 16 0.498047 16H16.502C16.7772 16 17 15.7764 17 15.5V4H0V15.5ZM6.00977 6.5C6.00977 6.31983 6.10605 6.1538 6.26221 6.06493C6.41836 5.97607 6.60998 5.9785 6.76414 6.07127L11.7446 9.07127C11.8944 9.1616 11.9863 9.3242 11.9863 9.49997C11.9863 9.67573 11.8944 9.83833 11.7446 9.92867L6.76414 12.9287C6.60988 13.0214 6.4182 13.0238 6.26221 12.935C6.10605 12.8462 6.00977 12.6802 6.00977 12.5V6.5Z",
    fill: "#D83C38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.498047 0C0.22276 0 0 0.223633 0 0.5V2.87523L3.85209 0H0.498047Z",
    fill: "#D83C38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00586 7.3833V11.6167L10.5204 9.5L7.00586 7.3833Z",
    fill: "#D83C38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.09761fcb8db651caf76fcb29dcda5b88.svg";
export { ForwardRef as ReactComponent };